export default __webpack_public_path__ + "static/material_07-546ab7fb41053ae069bf36a99d91e150.png";